import { Users, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { API } from '../../config/api';

export function SubscribersPanel({ subscribers, setSubscribers }) {
  const handleDelete = async (sub) => {
    if (!window.confirm(`Remove ${sub.email} from the mailing list?`)) return;
    try {
      await api.delete(`${API}/subscribers/${sub.id}`);
      setSubscribers((arr) => arr.filter(s => s.id !== sub.id));
      toast.success(`Removed ${sub.email}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Delete failed');
    }
  };

  return (
    <div className="space-y-6" data-testid="subscribers-content">
      <h2 className="font-cabinet text-2xl font-black uppercase tracking-tighter">SUBSCRIBERS</h2>

      {subscribers.length === 0 ? (
        <div className="bg-[#141414] border border-[#262626] p-12 text-center">
          <Users className="w-12 h-12 mx-auto text-[#A3A3A3] mb-4" />
          <p className="text-[#A3A3A3]">No subscribers yet.</p>
        </div>
      ) : (
        <div className="bg-[#141414] border border-[#262626]">
          <table className="data-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Subscribed</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map(sub => (
                <tr key={sub.id} data-testid={`subscriber-row-${sub.id}`}>
                  <td>{sub.email}</td>
                  <td className="text-[#A3A3A3]">{sub.name || '-'}</td>
                  <td className="font-mono text-[#A3A3A3]">{new Date(sub.subscribed_at).toLocaleDateString()}</td>
                  <td className="text-right">
                    <button
                      onClick={() => handleDelete(sub)}
                      className="text-[#FF3B30] hover:text-white p-1 transition-colors"
                      title="Remove from list"
                      data-testid={`delete-subscriber-${sub.id}`}
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
